/**
 * Build-time configuration from apps/web/.env. Vite bakes these values into the bundle.
 */

/** Product name shown in the browser tab, the sidebar and the sign-in page (VITE_APP_NAME). */
export const APP_NAME = import.meta.env.VITE_APP_NAME?.trim() || "AiYO Signal";

/**
 * API location (D-31), e.g. `http://localhost:3000` (VITE_API_BASE_URL). When empty, the dashboard
 * calls the API on its own origin, which only works behind a reverse proxy that forwards the API paths.
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? "").trim().replace(/\/+$/, "");

/** Absolute URL for an API path such as `/admin/apps`. */
export function apiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}

/** Public base URL of the API, for docs links and curl examples. */
export const PUBLIC_API_URL = API_BASE_URL || window.location.origin;
